<template>
	<a aria-role="button" v-bind:class="['menu-toggle-button', type, {'active' : active}]" href="#" v-on:click.stop.prevent="toggleMenu" @keypress.enter="toggleMenu">
		<span class="menu-label" v-text="menuLabel"></span>
		<i class="menu-icon"></i>
	</a>
</template>

<script>
export default {
	props: ['active', 'type', 'label'],
	computed: {
		menuLabel() {
			if (this.label) return this.label
			return ((this.active) ? this.$t('close') : ((this.type==='articles') ? this.$t('articles') : this.$t('menu')))
		},
	},
	methods: {
		toggleMenu() {
			this.$emit('toggleMenu')
		}
	}
}
</script>

<style lang="scss">
  @import "../../styles/scss/global/menu/toggle";
</style>